import { Routes, Route, HashRouter } from "react-router-dom";
import { GlobalContextProvider } from "@context/GlobalContext";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import Login from "@pages/login/Login";
import Home from "@pages/home/Home";
import Default from "@pages/default/Default";
import PrivateRoute from "@hooks/PrivateRoute";
import Cad from "@pages/cad/Cad";
import CadCadastro from "@pages/cad/cadCadastro/CadCadastro";
import UtilServices from "@services/UtilServices";
import { useEffect } from "react";
import CentralNotificacao from "@pages/centralnotificacao/CentralNotificacao";
import Historico from "@pages/cad/historico/Historico";
import SituacaoFiscal from "@pages/ecac/situacaoFiscal/SituacaoFiscal";
import SituacaoFiscalAnalitico from "@pages/ecac/situacaoFiscal/SituacaoFiscalAnalitico";
import IconEcac_Tema from "@icons/IconEcac_Tema";

export default function Rotas() {
  useEffect(() => {
    let tema = UtilServices.getStorage("tema");
    document.body.setAttribute("theme", tema);
  }, []);

  return (
    <HashRouter>
      <GlobalContextProvider>
        <Routes>
          <Route path="/" element={<Login />}></Route>
          <Route
            path="/home"
            element={
              <PrivateRoute>
                <Default>
                  <Home />
                </Default>
              </PrivateRoute>
            }
          ></Route>
          {/* CAD */}
          <Route
            path="/CAD"
            element={
              <PrivateRoute>
                <Default
                  icon={<i className="fa-solid fa-users"></i>}
                  title="Empresas"
                  app="CAD"
                  container="fluid"
                >
                  <Cad />
                </Default>
              </PrivateRoute>
            }
          ></Route>
          <Route
            path="/CAD/Cadastrar"
            element={
              <PrivateRoute>
                <Default
                  icon={<i className="fa-solid fa-building"></i>}
                  title="Cadastro e Edição"
                  app="CAD"
                  container="fluid"
                  back
                >
                  <CadCadastro />
                </Default>
              </PrivateRoute>
            }
          ></Route>
          <Route
            path="/CAD/Historico"
            element={
              <PrivateRoute>
                <Default
                  icon={<i className="fa-solid fa-clock-rotate-left"></i>}
                  title="Histórico"
                  app="CAD"
                  container="fluid"
                  back
                >
                  <Historico />
                </Default>
              </PrivateRoute>
            }
          ></Route>
          {/* ALT */}
          <Route
            path="/CentralNotificacao"
            element={
              <PrivateRoute>
                <Default
                  icon={<i className="fa-solid fa-bell"></i>}
                  title="Central de Notificações"
                  back
                >
                  <CentralNotificacao />
                </Default>
              </PrivateRoute>
            }
          ></Route>
          {/* ECAC */}
          <Route
            path="/ECAC/SituacaoFiscal"
            element={
              <PrivateRoute>
                <Default
                  icon={<i className="fa-regular fa-ballot-check"></i>}
                  title="Situação Fiscal"
                  container="fluid"
                  back
                >
                  <SituacaoFiscal />
                </Default>
              </PrivateRoute>
            }
          ></Route>
          <Route
            path="/ECAC/SituacaoFiscal/Analitico"
            element={
              <PrivateRoute>
                <Default
                  icon={<i className="fa-regular fa-ballot-check"></i>}
                  title="Analítico"
                  container="fluid"
                  back
                >
                  <SituacaoFiscalAnalitico />
                </Default>
              </PrivateRoute>
            }
          ></Route>
          <Route
            path="*"
            element={<h2 className="error404">Pagina não encontrada</h2>}
          />
        </Routes>
        {/* tooltips */}
        <Tooltip
          id="tooltip-001"
          className="default-tooltip"
          style={{ zIndex: 5 }}
        />
        <Tooltip
          id="tooltip-002"
          className="default-tooltip"
          place="left"
          style={{ zIndex: 5 }}
        />
        {/* especifico para notificacoes */}
        <Tooltip
          id="tooltip-003"
          className="default-tooltip"
          style={{ zIndex: 5 }}
        />
      </GlobalContextProvider>
    </HashRouter>
  );
}
